'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');
var React = require('react');

const useGetCitiesAndDistricts = () => {
  const [VN, setVN] = React.useState({});
  React.useEffect(() => {
    const getVNJsonFile = async () => {
      try {
        const response = await fetch(coreRenderer.mappingAssets.VN);
        const jsonResponse = await response.json();
        setVN(jsonResponse);
      } catch (e) {
        console.error(e);
      }
    };
    getVNJsonFile();
  }, []);
  const cities = VN["province"] || [];
  const districts = VN["district"] || [];
  return { cities, districts };
};

exports.useGetCitiesAndDistricts = useGetCitiesAndDistricts;
